module.exports = __webpack_public_path__ + "img/arrow_dark_grey.23edc0e9.svg";